import { connect } from "react-redux";
import OrganizationUtils from "../../../utils/organization";
import {
  UnsuspendUserModalDataProps,
  UnsuspendUserModalProps as _UnsuspendUserModalProps,
} from "./unsuspend-user-modal-view";
import { AppState } from "../../../store/AppState";
import {
  PickReduxDispatchProps,
  PickReduxStateProps,
} from "../../../util/typeUtil";
import { clearError, getUser, setUserSuspended } from "../../../actions";
import { ActionSender } from "../../../model/ActionSender";
import { addSenderArgument } from "../../../actions/actionHelpers";
import UnsuspendUserModal from "./unsuspend-user-modal-container";
import InProgressUtils from "../../../utils/in-progress";
import UserUtils, { UserWithStatus } from "../../../utils/user";

export interface UnsuspendUserModalProps
  extends Omit<_UnsuspendUserModalProps, keyof UnsuspendUserModalDataProps> {
  // for some reason in this case the omit does not remove all keys with keyof  RemoveGroupModalDataProps like it does
  // elsewhere. So far I have not been able to figure out a way to inspect/debug what is actually there to be removed.
}
// Input props provided to the wrapped component by this connect component, using mapStateToProps
type ReduxStateProps = PickReduxStateProps<
  _UnsuspendUserModalProps,
  UnsuspendUserModalProps
>;
// Dispatch props provided to the wrapped component by this connect component
type ReduxDispatchProps = PickReduxDispatchProps<
  _UnsuspendUserModalProps,
  UnsuspendUserModalProps
>;

const sender: ActionSender = { key: "unsuspend-user" };

function mapStateToProps(
  state: AppState,
  ownProps: UnsuspendUserModalProps
): ReduxStateProps {
  const user = ownProps.userId
    ? OrganizationUtils.selectOrganizationUser(ownProps.userId, state)
    : undefined;
  let userWithExtra: UserWithStatus | undefined = undefined;
  if (user) {
    userWithExtra = UserUtils.userWithStatus({
      ...user,
    });
  }
  return {
    isReady: InProgressUtils.selectNotInProgress(sender.key, state),
    user: userWithExtra,
  };
}

function areStatesEqual(next: AppState, prev: AppState): boolean {
  return (
    InProgressUtils.compareInProgressStates(next, prev) &&
    OrganizationUtils.compareOrganizationUsersStates(next, prev)
  );
}
const dispatchActions: ReduxDispatchProps = {
  onUnsuspendUser: (id: string) => setUserSuspended(sender, false, id) as any,
  onLoadUser: addSenderArgument(sender, getUser),
  onClearError: clearError,
};

export default connect<
  ReduxStateProps,
  ReduxDispatchProps,
  UnsuspendUserModalProps,
  AppState
>(mapStateToProps, dispatchActions, null, {
  areStatesEqual,
})(UnsuspendUserModal);
